import { Provider } from '@angular/core';
import { PaymentYear } from '@cassiopeia/integration';
import { AbstractPaymentDetailsDataFactory, PaymentDetailsColumn, PaymentDetailsDataFactory } from '@web/projection';

const ALDERS_TAX_CODE = 33;

export const providePaymentDetailsFactory = (): Provider => ({
  provide: PaymentDetailsDataFactory,
  useClass: PBUPaymentDetailsDataFactory,
});

export class PBUPaymentDetailsDataFactory extends AbstractPaymentDetailsDataFactory {
  protected getColumns(payments: PaymentYear[]): PaymentDetailsColumn[] {
    return [this.#lifetimeAnnuity(payments), this.#annuity(payments), this.#alders(payments)];
  }

  #lifetimeAnnuity(payments: PaymentYear[]): PaymentDetailsColumn {
    return {
      column: { key: 'lifetimeAnnuity', label: 'cas.paymentDetailsTaxedAmountLifetimeAnnuity' },
      amounts: payments.map(payment => this.monthly(this.sum(payment.lifetimeAnnuity?.details, 'totalFromDepot'))),
    };
  }

  #annuity(payments: PaymentYear[]): PaymentDetailsColumn {
    return {
      column: { key: 'annuity', label: 'cas.paymentDetailsTaxedAmountAnnuity' },
      amounts: payments.map(payment => this.monthly(this.sum(payment.annuity?.details, 'totalFromDepot'))),
    };
  }

  // The sum products are paid out as a one-off, so they are not divided into monthly amounts.
  #alders(payments: PaymentYear[]): PaymentDetailsColumn {
    return {
      column: { key: 'alders', label: 'cas.paymentDetailsTaxedAmountSum' },
      amounts: payments.map(payment =>
        this.yearly(this.sum(this.byTaxCode(payment.sum?.details, ALDERS_TAX_CODE), 'totalFromDepot')),
      ),
    };
  }
}
